import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {FETCH_CURRENT_STUDENT_TYPE} from '../constants/student-type';

function data(state = {}, action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_CURRENT_STUDENT_TYPE):
      return action.payload;
    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_CURRENT_STUDENT_TYPE]),
  error: getErrorReducer([FETCH_CURRENT_STUDENT_TYPE]),
  data
});
